import {recordDownloadRequest} from './telemetry.ts';
export type Release={target:string;channel:string;version:string;url:string;pub_date:string;size_bytes:number|null;sha256:string|null;notes:string};
export type ReleaseTarget='mac-arm64'|'win-x64';
export function validateRelease(data:unknown,target:ReleaseTarget='mac-arm64'):Release{
 if(!data||typeof data!=='object')throw new Error('下载信息校验失败，请重试。');
 const d=data as Release;
 let url:URL;try{url=new URL(d.url)}catch{throw new Error('下载信息校验失败，请重试。')}
 if(d.target!==target||d.channel!=='stable'||typeof d.version!=='string'||!d.version.trim()||url.protocol!=='https:'||!(target==='mac-arm64'?/\.dmg$/i:/\.(exe|msi)$/i).test(url.pathname)||Number.isNaN(Date.parse(d.pub_date))||typeof d.notes!=='string'||!(d.sha256===null||typeof d.sha256==='string')||!(d.size_bytes===null||typeof d.size_bytes==='number'&&Number.isFinite(d.size_bytes)&&d.size_bytes>0))throw new Error('下载信息校验失败，请重试。');
 return d;
}
/** 发布接口地址:CI 按环境注入；缺省走本地同源代理，不能隐式连接生产。
 *  scripts/test-releases.mjs 直接用 node 引这个文件,那里没有 import.meta.env,所以要兜底。 */
const buildEnv=(import.meta as {env?:Record<string,string|undefined>}).env??{};
const RELEASE_API_BASE=(buildEnv.VITE_RELEASE_API_BASE_URL||buildEnv.VITE_API_BASE_URL||'').replace(/\/+$/,'');

export async function getLatestRelease(signal?:AbortSignal,target:ReleaseTarget='mac-arm64'):Promise<Release>{
 const r=await fetch(`${RELEASE_API_BASE}/v1/releases/latest?target=${target}&channel=stable`,{headers:{Accept:'application/json'},signal});
 if(!r.ok)throw new Error(r.status===404?'下载链接暂未接入，请联系团队获取安装包。':'暂时无法获取版本信息，请重试。');
 return validateRelease(await r.json(),target);
}

/** 点击即取最新地址并开始下载(签名地址有有效期,每次点击都重新取)。 */
export async function startDownload(target:ReleaseTarget,signal?:AbortSignal):Promise<Release>{
 const latest=await getLatestRelease(signal??AbortSignal.timeout(12000),target);
 recordDownloadRequest(target,latest.version);
 const anchor=document.createElement('a');
 anchor.href=latest.url;
 anchor.rel='noopener';
 anchor.download=decodeURIComponent(new URL(latest.url).pathname.split('/').pop()||`Sciland.${target==='mac-arm64'?'dmg':'exe'}`);
 document.body.appendChild(anchor);
 anchor.click();
 anchor.remove();
 return latest;
}
